import Catalog from "./catalog";
import {setUrlObserveCatalogSection} from "./functions";
import {onReady} from "../../../../../modules/vegas/js/util";

function scrollLoader(container) {
	let catalogs = container.querySelectorAll('.catalog-products.with-load');
	let catalog = [...catalogs].pop();

	if (catalog) {
		let pagination = catalog.querySelector('.pagination');

		let changeLocation = catalog.dataset.withChangeLocation || false;

		if (pagination) {
			let rect = pagination.getBoundingClientRect();
			let load = rect.y && rect.y - 1500 < window.innerHeight;

			if (load) {
				let next = pagination.querySelector('.page-link[rel="next"]');
				if (next) {
					let link = next.href;

					pagination.remove();

					new Catalog()
						.setCatalogContainer(catalog)
						.withChangeLocation(changeLocation)
						.loadScrollProducts(catalog, link)
						.then(data => {
							if (changeLocation) {
								setUrlObserveCatalogSection(data.container);
							}
						})
				}
			}
		}
	}
}

document.addEventListener('scroll', () => scrollLoader(document));

const desktopSearch = document.querySelector('#desktop-search-results .search-advanced--wrapper-content');
desktopSearch?.addEventListener('scroll', () => scrollLoader(desktopSearch));

const mobileSearch = document.querySelector('#mobile-search-results');
mobileSearch?.addEventListener('scroll', () => scrollLoader(mobileSearch));

onReady(() => {
	let catalog = document.querySelector('.catalog-products.with-load');
	catalog && setUrlObserveCatalogSection(catalog);
})
